// Function to reorganize color swatches by price groups
function reorganizeColorSwatchesByPrice() {
  var currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  let product = {}

  try {
    product = JSON.parse(document.getElementById('ProductJson').innerHTML);
  } catch {
    return;
  }

  // This function re-runs on every swatch click, so clear out the wrappers the
  // previous run appended before building new ones -- otherwise the price
  // labels stack up. The .swatch__option nodes are the real swatches that get
  // moved into those wrappers, so lift them back out before removing.
  var $swatchOptions = $('.color-swatch .swatch__options');
  var $previousGroups = $swatchOptions.find('.swt-price-group');
  if ($previousGroups.length) {
    $swatchOptions.append($previousGroups.find('.swatch__option'));
    $previousGroups.remove();
  }
  var $colorSwatch = $('.color-swatch');
  var $previousLabel = $colorSwatch.find('.swt-price-group-label');
  if ($previousLabel.length) {
    $colorSwatch.prepend($previousLabel.children());
    $previousLabel.remove();
  }

  let sortingObject = {
    color: "",
    price: "",
    commPrice: ''
  }
  let sortDataArry = [];
  let elemntArray = [];
  product.variants.forEach((variant) => {
    if (variant.available) {
      let sortObj = Object.create(sortingObject);
      sortObj.color = variant.option1;
      sortObj.price = variant.price;
      sortObj.commPrice = variant.compare_at_price;
      sortDataArry.push(sortObj);
    }
  })

  const key = 'color';
  const unique = [...new Map(sortDataArry.map(item =>
    [item[key], item])).values()];

  // Group by price using vanilla JavaScript
  var grouped = unique.reduce((acc, item) => {
    const price = item.price;
    if (!acc[price]) {
      acc[price] = [];
    }
    // Omit the price property from the item
    const { price: _, ...itemWithoutPrice } = item;
    acc[price].push(itemWithoutPrice);
    return acc;
  }, {});
  
  if (Object.keys(grouped).length > 1) {
    var swatches = $('.color-swatch .swatch__options').find(".swatch__option");
    for (let index = 0; index < swatches.length; index++) {
      const element = swatches[index];
      elemntArray.push(element);
    }
    var keys = Object.keys(grouped);
    keys.sort(function (a, b) { return b - a });
    let colorSwath = [];

    const prices = Object.keys(grouped).map(price => parseFloat(price));

    // Find the lowest price
    const lowestPrice = (Math.min(...prices))/100;

    // Retrieve the object(s) corresponding to the lowest price
    const lowestPriceObjects = grouped[lowestPrice];

    
    for (var i = 0; i < keys.length; i++) {
      var val = grouped[keys[i]];
      let comPrice = val[0].commPrice > keys[i] ? val[0].commPrice : " ";
      let outerWrapper = "";
      let mdClass = "md-" + Math.floor(keys[i] / 100);
      let nmClass = "nm-" + Math.floor(keys[i] / 100);
      if (comPrice > 0) {
        if(lowestPrice!=(keys[i] / 100)){
          outerWrapper = $("<div>", { "class": "markdown-swt " + mdClass, "style": "position: relative; margin-right: 25px; width: fit-content;" }).append($("<div>", { "class": mdClass,"style": "line-height: normal;" }).append($("<span>", { "class": "product__price--old pdp_color_group_price" }).append($("<s>", {
            "tabindex": "0"
          }).text(currency.format(comPrice / 100))))).append($("<div>", {"class": mdClass,"style": "line-height: initial;" }).append($("<span>", { "class": "product__price--sale pdp_color_group_price", "tabindex": "0" }).text(currency.format(keys[i] / 100))));
        }else{
          // Clearance price colour is #D32121, the theme's own sale_color
          // setting. Plain `red` (#ff0000) is 4.00:1 on white -- under the
          // 4.5:1 this 14px text needs. #D32121 is 5.24:1 and matches the sale
          // price colour used elsewhere in the store.
          if ((lowestPrice/(comPrice / 100))< 0.51) {
            // The price span is built with its text in one step. The previous
            // version appended an empty <span tabindex="0">, then called
            // .text() on the parent div -- which wipes every child -- so the
            // span was destroyed and the price ended up as a bare text node
            // with no tab stop, before " Clearance" was appended after it.
            outerWrapper = $("<div>", { "class": "markdown-swt " + mdClass, "style": "position: relative; margin-right: 25px; width: fit-content;" })
              .append($("<div>", { "class": mdClass, "style": "line-height: normal;" })
                .append($("<div>", { "class": mdClass + " product__price--sale ", "style": "line-height: initial;font-size:14px;margin-top: 2px; color:#D32121;" })
                  .append($("<span>", { "class": "product__price--sale pdp_color_group_price", "tabindex": "0" }).text(currency.format(keys[i] / 100)))
                  .append($("<span>", { "class": "product__price--sale product__price--old pdp_grp_non_sale pdp_color_group_price ", "tabindex": "0", "style": "color:black;" }).text(" Clearance"))));
          }else{
            outerWrapper = $("<div>", { "class": "markdown-swt " + mdClass, "style": "position: relative; margin-right: 25px; width: fit-content;" }).append($("<div>", { "class": mdClass,"style": "line-height: normal;" }).append($("<span>", { "class": "product__price--old pdp_color_group_price" }).append($("<s>", {
              "tabindex": "0"
            }).text(currency.format(comPrice / 100))))).append($("<div>", {"class": mdClass,"style": "line-height: initial;" }).append($("<span>", { "class": "product__price--sale pdp_color_group_price", "tabindex": "0" }).text(currency.format(keys[i] / 100))));
          }
          
         }
        
      } else {
        outerWrapper = $("<div>", { "class": "non-markdown-swt " + nmClass, "style": "position: relative; margin-right: 25px;" }).append($("<div>", { "class": nmClass }).append($("<span>", { "class": "product__price--old pdp_grp_non_sale pdp_color_group_price ", "tabindex": "0" }).text(currency.format(keys[i] / 100)))).append($("<div>").append($("<span>", { "class": "product__price--old" }).text()));
      }
      for (let index = 0; index < val.length; index++) {
        const element = val[index];
        for (let i = 0; i < elemntArray.length; i++) {
          const pageElement = elemntArray[i];
          const swatchElement = pageElement.querySelector('.swatch-element');
          const inputElement = pageElement.querySelector('input[data-variant-option-value]');
          const colorValue = inputElement ? inputElement.value : '';
          
          if (colorValue == element.color) {
            pageElement.style.display = "inline-block";
            pageElement.style.position = "relative";
            if(outerWrapper!=""){
              outerWrapper.append(pageElement);
            }
            
          }
        }
      }
      colorSwath.push(outerWrapper);
    }

    let saleDiv = $("<div>", { "class": "swt-price-group", "style": "width: fit-content;" });
    let saleNonDiv = $("<div>", { "class": "swt-price-group", "style": "display: block" });
    for (let index = 0; index < colorSwath.length; index++) {
      const element = colorSwath[index];
      if (element.hasClass("non-markdown-swt")) {
        saleDiv.append(element);
      }
    }
    $('.color-swatch .swatch__options').append(saleDiv);
    for (let index = 0; index < colorSwath.length; index++) {
      const element = colorSwath[index];
      if (element.hasClass("markdown-swt")) {
        saleNonDiv.append(element);
      }
    }
    $('.color-swatch .swatch__options').append(saleNonDiv);
    document.querySelector('.color-swatch .swatch__options').classList.add('display-block-pdp-swt');

    $('.color-swatch').css('display', 'block');
    $('.color-swatch').find('.option-title').addClass('pdp-color-group-heading');

    let lableDv = $("<div>", { "class": "swt-price-group-label", "style": "display: inline-flex;" });
    lableDv.append($('.pdp-color-group-heading').addClass('grp-lable-color grp-lable')).append($('.color-swatch .options-selection__option-name').addClass('grp-lable-color'))
    $('.color-swatch').prepend(lableDv);

  }

  var keys = Object.keys(grouped);
  keys.sort((a, b) => b - a);
  let dataValues = "";
   
  for (var i = 0; i < keys.length; i++) {
    var val = grouped[keys[i]];
    let comPrice = val[0].commPrice > keys[i] ? val[0].commPrice : " ";
    let calcValue = Math.floor(keys[i] / 100);

    if (comPrice > 0) {
      let mdClass = "md-" + calcValue;
      dataValues += mdClass + '#';
        let markdownDivs = document.querySelectorAll('.markdown-swt');

        markdownDivs.forEach(div => {
            if (div.classList.contains(mdClass)) {
                let productSwatches = div.querySelectorAll('.swatch__option');

                productSwatches.forEach(swatch => {
                    swatch.classList.add(mdClass);
                });
            }
        });

         // Add the condition for .swatch__option without .markdown-swt or .non-markdown-swt
      let samePriceSwatches = document.querySelectorAll('.swatch__option');
      samePriceSwatches.forEach(swatch => {
        if (!swatch.closest('.markdown-swt') && !swatch.closest('.non-markdown-swt')) {
          swatch.classList.add(mdClass);
          swatch.classList.add('samePrice');
        }
      });
    } else {
      let nmClass = "nm-" + calcValue;
      dataValues += nmClass + '#';
        let nonMarkdownDivs = document.querySelectorAll('.non-markdown-swt');
        nonMarkdownDivs.forEach(div => {
          if (div.classList.contains(nmClass)) {
            let productSwatches = div.querySelectorAll('.swatch__option');

            productSwatches.forEach(swatch => {
                swatch.classList.add(nmClass);
            });
          }
        });

      // Add the condition for .swatch__option without .markdown-swt or .non-markdown-swt
      let samePriceSwatches = document.querySelectorAll('.swatch__option');
      samePriceSwatches.forEach(swatch => {
        if (!swatch.closest('.markdown-swt') && !swatch.closest('.non-markdown-swt')) {
          swatch.classList.add(nmClass);
          swatch.classList.add('samePrice');
        }
      });
    }
  }

  // Get all elements with the class 'samePrice'
  let samePriceElements = document.querySelectorAll('.samePrice');

  dataValues = dataValues.slice(0, -1);

  samePriceElements.forEach(swatch => {
    swatch.setAttribute('data-group', dataValues);
    swatch.classList.add('price-tag');
  });

  document.querySelectorAll('.markdown-swt *, .non-markdown-swt *').forEach(element => {
    element.setAttribute('data-group', dataValues);
    element.classList.add('price-tag');
  });

  var priceList = dataValues.split('#');
 
  var allPriceTagElements = document.querySelectorAll('.price-tag');

  var priceGroupsElements = [];

  priceList.forEach(classInList => {
    let elementsWithClass = Array.from(allPriceTagElements).filter(element => element.classList.contains(classInList));

    if (elementsWithClass.length > 0) {
      priceGroupsElements.push(elementsWithClass);
    }
  });

  let singlePriceAvailable = false;
  const valueLabel = document.querySelector('.color-value-spn');
  const colorLabel = document.querySelector('.color-label');
  const focusableSelector = 'input, span, button, textarea, select, a[href], [tabindex]:not([tabindex="-1"]), [tabindex="0"]';

  priceGroupsElements.forEach((priceGroup) => {
    priceGroup.forEach((element) => {
      // A keydown listener used to be bound here calling handleTabShiftKeyDown,
      // but that function is not defined anywhere in the theme -- so every key
      // press on a price-tag element threw ReferenceError. It only surfaced
      // once the swatches became focusable; before that nothing could put
      // keyboard focus on them to fire it.
      //
      // Removing it costs nothing: the grouping moves the swatches into their
      // price wrappers in the DOM, so the browser's own Tab order already
      // follows the visual grouping.
      if (element._swtTabHandler) {
        element.removeEventListener('keydown', element._swtTabHandler);
        delete element._swtTabHandler;
      }

      if (element.classList.contains('samePrice')) {
       singlePriceAvailable = true;
      }
    });
  });

  function setFocusToElement(element, focusableSelector) {
    let focusTarget = element.querySelector(focusableSelector);

    if (focusTarget) {
      focusTarget = focusTarget.querySelector(focusableSelector) || focusTarget;
    } else {
      focusTarget = element;
    }
    focusTarget.focus();
  }

  let searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('variant')) {
    let param = searchParams.get('variant');
    let currentObject = product.variants.find(item => item.id == param);
    let currentId = "";
    if (currentObject != null) {
      currentId = currentObject.option1
    }
    if (currentId != "") {
      $('.thumbnail-list__item').removeClass('hide-imgs');
      $('.thumbnail-list__item').each(function () {
        let dataValue = $(this).data("varinet-id");
        if (currentId != dataValue) {
          $(this).addClass("hide-imgs");
        }
        if (dataValue.indexOf(".mp4") !== -1) {
          $(this).removeClass("hide-imgs");
        }
        if (dataValue.toLowerCase().indexOf("common") !== -1) {
          $(this).removeClass("hide-imgs");
        }
      })
    }
  }
}

// Call on page load
window.addEventListener('load', (event) => {
  setTimeout(function() {
        reorganizeColorSwatchesByPrice();
      }, 1200);

// Listen to the radio's own change event rather than a click on the label and
// a keydown on the swatch wrapper. change fires however the selection is made
// -- mouse, Enter/Space, or the arrow keys that move through a radio group --
// so the colour name and the price grouping stay in step with the real state.
// The colour is read from data-value on the swatch; it used to come from that
// element's aria-label, which has been removed because a plain <div> maps to
// role=generic and ignores aria-label anyway.
$(document).on('change', '.swatch__option input[data-variant-option-value]', function () {
  // aria-checked lives on the swatch, not the input, so it has to be refreshed
  // for the whole group every time the selection moves.
  const $group = $(this).closest('[role="radiogroup"]');
  $group.find('.swatch-element[role="radio"]').attr('aria-checked', 'false');
  $(this).siblings('.swatch-element[role="radio"]').attr('aria-checked', 'true');

  const $swatch = $(this).siblings('.swatch-element.color');
  if (!$swatch.length) return;

  const color = $swatch.attr('data-value') || this.value;
  if (!color) return;

  // Scoped to this option's own group and to the value span only. Unscoped,
  // this wrote the colour into every option label on the page -- including
  // Size -- and now that the label is "<span>Colour</span>: <span>Navy</span>"
  // it would also overwrite the option's name with its value.
  $group
    .find('.options-selection__option-name span:last-of-type')
    .text(color);

  // Reorganize swatches by price groups
  setTimeout(function() {
    reorganizeColorSwatchesByPrice();
  }, 150);
});

// The swatch is the control now, so it has to be operable. A mouse click still
// reaches the native input through the <label for>, but a keyboard press on the
// swatch does not -- role="radio" means Enter and Space must both select it.
$(document).on('keydown', '.swatch-element[role="radio"]', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

  event.preventDefault();

  const input = $(this).siblings('input[data-variant-option-value]')[0];
  if (!input || input.checked) return;

  input.click();
});

// The Samita product-label markup ("WARMEST", "SALE") is injected by the app,
// so it is not in the theme's templates and cannot be given a tabindex there.
// It also arrives after load and is re-injected on variant change and when the
// gallery re-renders, which is why this watches for new labels rather than
// running once.
const SAMITA_LABEL_TEXT = '.samita_productLabel-content-text > div';

function makeSamitaLabelsFocusable(root) {
  const scope = root && root.querySelectorAll ? root : document;

  scope.querySelectorAll(SAMITA_LABEL_TEXT).forEach(function (el) {
    // Skip anything already focusable, and empty wrappers -- a tab stop that
    // announces nothing is worse than no tab stop.
    if (el.hasAttribute('tabindex')) return;
    if (!el.textContent.trim()) return;

    el.setAttribute('tabindex', '0');
  });
}

makeSamitaLabelsFocusable();

if (window.MutationObserver) {
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        if (node.matches && node.matches(SAMITA_LABEL_TEXT)) {
          makeSamitaLabelsFocusable(node.parentNode);
        } else {
          makeSamitaLabelsFocusable(node);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}

// Key Features copy comes out of `| metafield_tag`, so the <p> wrappers are
// generated by Shopify and there is nowhere in keyfeautures.liquid to put a
// tabindex on them. Without one the copy is skipped entirely by tab navigation
// -- the headings around it are focusable, the text between them is not.
// Same approach as the accordion panels: the text-bearing node becomes the tab
// stop, so a screen reader announces it when focus lands there.
const KEY_FEATURES_TEXT = '.key-features-text p, .key-features-text li';

function makeKeyFeaturesTextFocusable(root) {
  const scope = root && root.querySelectorAll ? root : document;

  scope.querySelectorAll(KEY_FEATURES_TEXT).forEach(function (el) {
    if (el.hasAttribute('tabindex')) return;
    // An empty <p> (metafields often end with one) would be a tab stop that
    // announces nothing.
    if (!el.textContent.trim()) return;

    el.setAttribute('tabindex', '0');
  });

  // Rich text that is a bare string renders with no <p> at all; fall back to
  // the metafield wrapper so the copy is still reachable.
  scope.querySelectorAll('.key-features-text .metafield-rich_text_field').forEach(function (el) {
    if (el.hasAttribute('tabindex')) return;
    if (el.querySelector('p, li')) return;
    if (!el.textContent.trim()) return;

    el.setAttribute('tabindex', '0');
  });
}

makeKeyFeaturesTextFocusable();

// Size guide tables are read-only data, so nothing in them is focusable and a
// keyboard user tabs straight past the whole chart. Making each cell a tab stop
// is the only way to walk the numbers without a screen reader's table-browse
// mode. The .size-chart fallback covers charts authored as a Shopify page
// (popup-size-chart.liquid renders those through `pages[...].content`, which
// has no .tbl-size-guide class on its tables).
const SIZE_GUIDE_CELLS = '.tbl-size-guide th, .tbl-size-guide td,' +
  ' .size-chart table th, .size-chart table td';

function makeSizeGuideCellsFocusable(root) {
  const scope = root && root.querySelectorAll ? root : document;

  scope.querySelectorAll(SIZE_GUIDE_CELLS).forEach(function (cell) {
    if (cell.hasAttribute('tabindex')) return;
    // Spacer cells are common in these charts; a tab stop that announces
    // nothing is worse than no tab stop.
    if (!cell.textContent.trim()) return;

    cell.setAttribute('tabindex', '0');
  });
}

makeSizeGuideCellsFocusable();

// Rich text sections and FAQ answers are both `richtext` settings, and Shopify
// validates those on upload: only <p>, <br>, <strong>, <em>, list tags and
// <a href|title|target> are allowed, so a tabindex written into the template
// JSON is rejected outright. Adding it here is the only way to make the copy
// reachable -- and it survives a merchant editing the text in the customizer,
// which writing it into the JSON would not.
//
// The FAQ's <dd> panels are toggled with display:none, so the ones that are
// closed keep their tabindex without becoming tab stops.
const RICH_TEXT_PARAGRAPHS = '.rich-text__content p, .rich-text__content li,' +
  ' .faq-accordion dd p, .faq-accordion dd li,' +
  ' .layer-guide__attribute dd p, .layer-guide__attribute dd li';

function makeRichTextFocusable() {
  document.querySelectorAll(RICH_TEXT_PARAGRAPHS).forEach(function (el) {
    if (el.hasAttribute('tabindex')) return;
    // The customizer's editor leaves empty <p></p> behind as spacing; a stop
    // there is a keypress that announces nothing.
    if (!el.textContent.trim()) return;
    // Opt-out for the Custom HTML answer: class="noindex" on a line, or on any
    // wrapper around it, keeps this pass off it -- the merchant writing that
    // markup by hand is the one who knows a line should not be its own stop.
    if (el.closest('.noindex')) return;

    // When the whole line sits inside one <strong> -- the editor's way of
    // writing a sub-heading, e.g. <p><strong>CuddlDuds.com</strong></p> -- the
    // stop goes on the <strong> rather than the <p>. Same single stop either
    // way, but the emphasis is then part of the focused element.
    let target = el;
    const emphasis = el.querySelector('strong, b');
    if (emphasis && emphasis.textContent.trim() === el.textContent.trim()) {
      target = emphasis;
    }

    // Re-checked because the target may now be the <strong>, which the guard
    // above did not cover.
    if (target.hasAttribute('tabindex')) return;

    target.setAttribute('tabindex', '0');
  });
}

makeRichTextFocusable();

// The Fancybox zoom button's name comes from the {{ZOOM}} token in its template
// and renders as the bare word "Zoom", which does not say which way the press
// goes. It is a toggle: while the image is scaled down the press zooms to actual
// size, and once zoomed it scales back to fit. Naming it after what the next
// press does is the same treatment Fancybox already gives its slideshow button
// through PLAY_START / PLAY_STOP. Done here rather than in vendors.js so it
// survives the next Fancybox upgrade.
function setFancyboxZoomLabel(scaledDown) {
  const button = document.querySelector('[data-fancybox-zoom]');
  if (!button) return;

  const label = scaledDown ? 'Zoom in' : 'Zoom out';
  button.setAttribute('aria-label', label);
  button.setAttribute('title', label);
}

function getFancyboxInstance() {
  const fancybox = window.jQuery && $.fancybox;
  if (!fancybox || typeof fancybox.getInstance !== 'function') return null;

  const instance = fancybox.getInstance();
  if (!instance || typeof instance.isScaledDown !== 'function') return null;

  return instance;
}

// Fancybox dispatches its callbacks as events on document with a .fb suffix and
// hands the instance to the handler. afterShow covers opening the lightbox and
// moving between slides; there is no event for a rescale, so the press itself is
// handled below.
// afterLoad as well as afterShow: a large image is still downloading when the
// slide is shown, so on afterShow the .fancybox-image element does not exist
// yet and there is nothing to tag. That is why the alt and the tabindex landed
// on some slides and not others -- it was a race with the image loading, so it
// followed the cache rather than anything in the markup.
$(document).on('afterShow.fb afterLoad.fb', function (event, instance) {
  if (!instance) return;

  if (typeof instance.isScaledDown === 'function') {
    setFancyboxZoomLabel(instance.isScaledDown());
  }

  setFancyboxImageTabindex(instance);
});

// Announce the popup on open. Fancybox moves focus into its container, but it
// lands on whatever happens to be first -- for the size chart that is the
// heading, which reads "SIZE GUIDE" and says nothing about a popup having
// opened. Focusing the announcer instead is what the cart drawer does through
// #PopupCartID in assets/z__jsAjaxCart.js.
//
// afterShow only, not afterLoad: the announcement should fire once as the popup
// appears, and afterLoad runs again for preloaded neighbouring slides.
$(document).on('afterShow.fb', function (event, instance) {
  const container = instance && instance.$refs && instance.$refs.container && instance.$refs.container[0];
  if (!container) return;

  const announcer = container.querySelector('[data-popup-announce]');
  if (!announcer) return;

  // Deferred a frame so the popup is painted before focus moves; Fancybox sets
  // its own focus during the same tick and would otherwise take it back.
  window.requestAnimationFrame(function () {
    if (!container.contains(announcer)) return;

    announcer.focus();
  });
});

// Fancybox keeps the neighbouring slides in the DOM either side of the current
// one (fancybox-slide--previous / --next), so a blanket tabindex on
// .fancybox-image would put two images the customer cannot see into the tab
// order. Only the slide carrying fancybox-slide--current gets one, and it is
// taken off the rest every time the slide changes.
function setFancyboxImageTabindex(instance) {
  const container = instance.$refs && instance.$refs.container;
  if (!container) return;

  container.find('.fancybox-image').each(function () {
    if (!this.closest('.fancybox-slide--current')) {
      this.removeAttribute('tabindex');
      return;
    }

    this.setAttribute('tabindex', '0');

    // Fancybox builds this <img> itself with no alt, so focusing it would
    // announce "graphic" and nothing else.
    if (!this.getAttribute('alt')) {
      const alt = getFancyboxSlideAlt(instance.current);
      if (alt) this.setAttribute('alt', alt);
    }
  });
}

// opts.caption is the obvious source but it is empty on nearly every slide:
// this build of Fancybox ships no default caption function, so unless a caption
// is passed explicitly the slide stores "". opts.$orig -- the <a> that opened
// the lightbox -- is where the text actually lives: its title attribute, or
// failing that the alt on the thumbnail inside it. See the gallery link in
// snippets/product__images.liquid, which carries both.
function getFancyboxSlideAlt(slide) {
  if (!slide || !slide.opts) return '';

  const caption = slide.opts.caption;
  if (caption && typeof caption === 'string') {
    return $('<div>').html(caption).text().trim();
  }

  const $orig = slide.opts.$orig;
  if (!$orig || !$orig.length) return '';

  return ($orig.attr('title') || $orig.find('img').first().attr('alt') || '').trim();
}

// Capture phase, so this runs before Fancybox acts on the press: isScaledDown()
// is still the state from before, and the state after is its opposite. Reading
// it in the bubble phase instead would mean waiting out the zoom animation
// before the answer settled.
document.addEventListener('click', function (event) {
  if (!event.target.closest) return;
  if (!event.target.closest('[data-fancybox-zoom]')) return;

  const instance = getFancyboxInstance();
  if (!instance) return;

  setFancyboxZoomLabel(!instance.isScaledDown());
}, true);

// Left arrow from the size chart's "SIZE GUIDE" heading moves focus to that
// popup's close button, so there is a way out that does not mean tabbing past
// the whole chart. Keyed on #sizechartheader rather than a heading selector:
// the shortcut belongs to the size chart, and a generic rule would take the
// arrow key away from headings in every other lightbox on the site.
function handleSizeChartHeaderKeydown(event) {
  if (event.key !== 'ArrowLeft' && event.key !== 'Left') return;

  const header = event.target.closest && event.target.closest('#sizechartheader');
  if (!header) return;

  // Scope the close button to this popup's own container, so a lightbox left
  // open behind it cannot be the one that gets closed. .fancybox-close-small
  // first: that is the close this popup renders -- the toolbar's
  // .fancybox-button--close only exists on galleries.
  const container = header.closest('.fancybox-container') || document;
  const closeButton = container.querySelector('.fancybox-close-small, [data-fancybox-close], .fancybox-button--close');
  if (!closeButton) return;

  // Fancybox binds Left to "previous slide" on document, and an unhandled arrow
  // scrolls the page behind the popup; preventDefault stops both.
  event.preventDefault();
  closeButton.focus();
}

// Capture phase on document: the heading only exists inside the lightbox once
// Fancybox has moved it there, so there is nothing to bind to at load time, and
// capture runs before Fancybox's own document-level arrow handling.
document.addEventListener('keydown', handleSizeChartHeaderKeydown, true);

// Backwards out of the Slippers table's first row header (#last-cell-skip, "S")
// goes to that table's "Size" column header (#focus-from-last-cel) rather than
// to the cell in between. Left arrow and Shift+Tab both do it, so it works
// whether the customer is reading across the row or tabbing through the chart.
function handleSizeGuideSkipBackKeydown(event) {
  const isArrowLeft = event.key === 'ArrowLeft' || event.key === 'Left';
  const isShiftTab = event.key === 'Tab' && event.shiftKey;

  if (!isArrowLeft && !isShiftTab) return;

  if (!event.target.closest) return;
  if (!event.target.closest('#last-cell-skip')) return;

  const target = document.getElementById('focus-from-last-cel');
  if (!target) return;

  // Without this the Shift+Tab still runs and lands a stop further back, and a
  // stray arrow scrolls the chart sideways.
  event.preventDefault();
  target.focus();
}

document.addEventListener('keydown', handleSizeGuideSkipBackKeydown, true);

// The express-checkout wallets are rendered by Shopify's
// <shopify-accelerated-checkout-cart>. The buttons themselves sit in closed
// shadow roots and cross-origin iframes, so nothing in the theme can reach them
// -- but the iframes are light DOM, and an <iframe> with no title is announced
// as nothing more than "frame". Naming each one after the wallet that owns it
// is the part of this that is ours to fix.
const WALLET_NAMES = {
  'SHOP-PAY-WALLET-BUTTON': 'Shop Pay',
  'SHOPIFY-PAYPAL-BUTTON': 'PayPal',
  'SHOPIFY-GOOGLE-PAY-BUTTON': 'Google Pay',
  'SHOPIFY-APPLE-PAY-BUTTON': 'Apple Pay'
};

function nameWalletFrames() {
  document.querySelectorAll('.additional-checkout-buttons iframe').forEach(function (frame) {
    if (frame.getAttribute('title')) return;

    // Walk up to the wallet custom element -- the iframe is nested a few levels
    // inside it, and which wallet it belongs to is only knowable from there.
    let walletName = '';
    let el = frame.parentElement;
    while (el && !walletName) {
      walletName = WALLET_NAMES[el.tagName] || '';
      el = el.parentElement;
    }

    frame.setAttribute('title', walletName ? walletName + ' checkout' : 'Express checkout');
  });
}

// Naming the button itself is impossible from out here, but the wallet's host
// element is light DOM and can be turned into a labelled group around it. A
// screen reader announces a group's label when focus moves into it, so tabbing
// to Shop Pay reads "Pay with Shop Pay" even though the <button> inside the
// closed shadow root is unreachable.
//
// role="group" rather than role="button": the real button is a focusable
// descendant, so claiming the host is a button would nest one inside the other
// and add a second, fake stop. A group adds no stop and no behaviour.
function nameWalletHosts() {
  Object.keys(WALLET_NAMES).forEach(function (tagName) {
    const selector = '.additional-checkout-buttons ' + tagName.toLowerCase();

    document.querySelectorAll(selector).forEach(function (host) {
      if (host.hasAttribute('role')) return;

      host.setAttribute('role', 'group');
      host.setAttribute('aria-label', 'Pay with ' + WALLET_NAMES[tagName]);
    });
  });
}

// The wallets are injected well after DOMContentLoaded -- the PayPal SDK alone
// takes a second -- and each one swaps its iframe in on its own schedule, so a
// single pass on load would run before any of them exist.
const checkoutButtons = document.querySelector('.additional-checkout-buttons');
if (checkoutButtons) {
  nameWalletFrames();
  nameWalletHosts();

  if (window.MutationObserver) {
    new MutationObserver(function () {
      nameWalletFrames();
      nameWalletHosts();
    }).observe(checkoutButtons, { childList: true, subtree: true });
  }
}
});
